// extracted by mini-css-extract-plugin
export var checked = "styles-module--checked--3-FQY";
export var container = "styles-module--container--1OB22";
export var hidden = "styles-module--hidden--StSfV";
export var labelText = "styles-module--labelText--1bYgX";
export var unchecked = "styles-module--unchecked--1b_X3";